import { axiosInstance } from "../../../axios/axiosInstance";

const API_SYSTEM_SETTINGS_URL = "admin/system-settings";
const API_UPDATE_SPONSOR_URL = API_SYSTEM_SETTINGS_URL + "/update_ad_charges";

export const updateSponsor = (dataToBeSent) => {
  return axiosInstance.post(API_UPDATE_SPONSOR_URL, dataToBeSent);
};